"use client";
import { getBaseURL, getPublicAssetPath } from "@/utils";
import { Metadata } from "next";
import Link from "next/link";
import { usePathname } from "next/navigation";
import React from "react";
import getClientText from "./i18n";

export const metadata: Metadata = {
  title: "Error 404",
};

const NotFound = () => {
  const url = usePathname();
  const lang = url.includes("/th/") ? "th" : "en";
  const t = getClientText(lang, "error");
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden">
      <div className="px-6 py-16 text-center font-semibold before:container before:absolute before:left-1/2 before:aspect-square before:-translate-x-1/2 before:rounded-full before:bg-[linear-gradient(180deg,#4361EE_0%,rgba(67,97,238,0)_50.73%)] before:opacity-10 md:py-20">
        <div className="relative">
          <img
            src={getPublicAssetPath("/assets/img/error/404-dark.svg")}
            alt="404"
            className="dark-img mx-auto -mt-10 w-full max-w-xs object-cover md:-mt-14 md:max-w-xl"
          />
          <img
            src={getPublicAssetPath("/assets/img/error/404-light.svg")}
            alt="404"
            className="light-img mx-auto -mt-10 w-full max-w-xs object-cover md:-mt-14 md:max-w-xl"
          />
          <p className="mt-5 text-base dark:text-white">{t["page404"]}</p>
          <Link
            href={`${getBaseURL(lang)}/signin`}
            className="btn btn-gradient mx-auto !mt-7 w-max border-0 uppercase shadow-none"
          >
            {t["backToHome"]}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
